import '@formkit/themes/genesis'

import { createApp } from "vue";
import Appa from './Appa.vue';

import {
  // dateFilters,
  AppSnackbar,
  AppConfirmationDialog,
  bulkDownloadCorsProxyService ,
  corsProxyService,
  runtimeConfigurationService,
  store,
  // InfoSlot,
  // ConditionalInput,
  // AutocompleteInput,
  // CustomNumber,
  // CustomURL,
  // UniqueIdentifierInput,
  // Groupedinput,
  // FileUpload,
  // DatePicker,
  // DateTimePicker,
  SelectedFacetsOverview,
  // vueKeycloak,
  helpers,
} from '@piveau/piveau-hub-ui-modules';
import '@piveau/piveau-hub-ui-modules/styles';
import { plugin as piveauPlugin } from '@piveau/sdk-vue'

import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';
import './styles/styles.scss';

import 'popper.js';
import 'bootstrap';
import 'leaflet/dist/leaflet.css';


import runtimeConfig from '../config/runtime-config';
import { glueConfig as GLUE_CONFIG, i18n as messages } from '../config/user-config';
const stickyLocale = helpers.createStickyLocale('de');

import VueClickAway from "vue3-click-away";
import { i18n } from "./setup/i18n";
import { setupFontawesome } from "./setup/fontawesome";
import { setupProgressbar } from "./setup/progressbar";
import { setupMeta } from "./setup/meta";
import { setupPiwik } from "./setup/piwik";
import { setupSkeletor } from "./setup/vue-skeletor";
import { setupHeaderFooter } from "./setup/setupHeaderFooter";
import { setupPiveauHubUiModules } from "./setup/setupPiveauHubUiModules";
import { setupFormKit } from "./setup/formkit";
import keycloakPlugin from './services/keycloakService';
import { createPvRouter } from './setup/router';
import { configureMarked } from './utils/configureMarked';

const app = createApp(Appa)

app.use(runtimeConfigurationService, runtimeConfig, { baseConfig: GLUE_CONFIG, debug: true, useExperimentalRuntimeParser: true });
const userConfig = app.config.globalProperties.$env;

const hubSearchApiBaseUrl = userConfig.api.baseUrl;
const host = window.location.host;

setupFontawesome(app);
setupProgressbar(app);
setupSkeletor(app);
setupMeta(app);
setupHeaderFooter(app);
setupPiveauHubUiModules(app, userConfig);
setupFormKit(app);

app.use(piveauPlugin, {});

app.use(VueClickAway);
// Vue.use(corsProxyService, env.api.vueAppCorsproxyApiUrl);

app.use(corsProxyService, userConfig.api.corsproxyApiUrl)
app.use(bulkDownloadCorsProxyService, userConfig, userConfig.api.corsproxyApiUrl);

app.use(store);

const i18nInstance = i18n({
  locale: userConfig.languages.locale,
  fallbackLocale: userConfig.languages.fallbackLocale,
  messages,
})
app.use(i18nInstance);


app.component('AppSnackbar', AppSnackbar);
app.component('AppConfirmationDialog', AppConfirmationDialog);
app.component('SelectedFacetsOverview', SelectedFacetsOverview);

app.config.globalProperties.i18n = i18nInstance;

configureMarked();


if (userConfig.authentication.useService) {
  app.use(keycloakPlugin, {
    config: {
      rtp: userConfig.authentication.rtp,
      ...userConfig.authentication.keycloak,
    },
    init: {
      ...userConfig.authentication.keycloakInit,
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      flow: 'standard',
      silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
      responseMode: 'fragment',
      checkLoginIframe: false,
      enableLogging: true,
    },
    onReady: async () => {
      console.log("Keycloak uloaded");
      const router = await createPvRouter({
        hubSearchApiBaseUrl,
        host,
        userConfig,
      });
      // router.currentRoute.value.query = {};
      router.beforeEach(stickyLocale);
      app.use(router);
      setupPiwik(app, router, userConfig)
      app.mount('#app');
    },
    onInitError: async (error: Error) => {
      console.log("Keycloak dloaded", error);
      const router = await createPvRouter({
        hubSearchApiBaseUrl,
        host,
        userConfig,
      });
      router.beforeEach(stickyLocale);
      app.use(router);
      setupPiwik(app, router, userConfig)
      app.mount('#app');
    }
  });
} else {
    const router = await createPvRouter({
      hubSearchApiBaseUrl,
      host,
      userConfig,
    });
    router.beforeEach(stickyLocale);
    app.use(router);
    setupPiwik(app, router, userConfig)

  app.use(router);
  app.mount('#app');
}
